<template>
    <section class="case-wrapper" style="background: #fff; heigith: 100%;">
        <div class="case-tab-wrapper">
            <a :class="{tabActive: tabActive == item.id}" @click="getData(item.id)" v-for="(item, index) in category" :key="item.id" href="javascript:;">{{item.name}}</a>
        </div>
        <Tabs v-model="active" class="m-tab-wrapper" @change="setData" style="margin-bottom: 18px;">
            <Tab v-for="item in category" :title="item.name" :key="item.id">{{item.id}}</Tab>
        </Tabs>
        <vue-waterfall-easy
            @click="show=true"
            ref="waterfall"
            :imgWidth="241"
            :height="height" 
            :maxCols="5"
            :imgsArr="imgsArr">
            <div slot="waterfall-over">
                <span v-if="imgsArr.length == 0">数据加载完毕</span>
            </div>
            <div class="case-list-item" slot-scope="props">
                <div>
                    {{props.value.content}}
                </div>
                <div class="case-list-bottom">
                    <div class="case-list-front-wrapper" style="width: 80%;">
                        <img :src="props.value.avatar" alt="">
                        <span>{{props.value.user}}</span>
                    </div>
                    <div>
                        <i class="ivu-icon ivu-icon-ios-heart-outline"></i>
                        <i>{{props.value.count}}</i>
                    </div>
                </div>
            </div>
        </vue-waterfall-easy>
        <a href="javascript:;" class="more" @click="show=true">查看更多</a>
        <Modal v-model="show" footer-hide width="349">
            <div class="case-dialog-wrapper">
                <div class="case-dialog-top">
                    <img :src="require('@/assets/dialog_top_icon.png')" />
                </div>
                <img :src="require('@/assets/download.png')" />
                <p>
                    扫码下载透透医美app<br />发现取悦自己的美
                </p>
            </div>
        </Modal>
        <div class="app-button-wrapper">
            <a @click="download" href="javascript:;">在APP内打开</a>
        </div>
    </section>
</template>
<script>
import vueWaterfallEasy from 'vue-waterfall-easy'
import Tab from 'vant/lib/tab';
import Tabs from 'vant/lib/tabs';
import 'vant/lib/tab/style';
import 'vant/lib/tabs/style';
import { setTimeout } from 'timers';

export default {
    components: {
        vueWaterfallEasy,
        Tab,
        Tabs,
    },
    data() {
        return {
            active: '',
            imgsArr: [],
            category: [],
            show: false,
            tabActive: '',
            height: 1000
        }
    },
    async created() {
        await this.getCategory()
    },
    mounted() {
        if (window.screen.width < 710) {
            this.height = window.screen.height - 300
        } else {
            this.height = 1000
        }
        this.getData('')
    },
    methods: {
        download() {
            console.log(111111)
            function isAndroid_ios() {
                const u = navigator.userAgent, app = navigator.appVersion;
                const isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1; //android终端或者uc浏览器
                const isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
                return isAndroid==true?true:false;
            }
            if (isAndroid_ios()) {
                // 安卓
                window.location.href = 'http://zhushou.360.cn/detail/index/soft_id/3841835?recrefer=SE_D_'
            } else {
                // ios
                window.location.href = 'https://apps.apple.com/cn/app/透透医美-爱美女性精选的整形美容比价信息平台/id1102277119'
            }
        },
        setData(index) {
            this.getData(this.category[index].id)
        },
        getCategory() {
            this.$axios.get('/api/case/category/')
            .then(res => {
                const category = res.data.map(item=>{
                    return {
                        name: item.name,
                        id: item.id
                    }
                })
                this.category = [{ name: '推荐', id: '' }, ...category]
            })
        },
        getData(id) {
            this.$refs.waterfall.over = false
            this.tabActive = id
            this.$axios({
                url: '/api/app/case/',
                method: 'get',
                params: { category: id, page: 1, page_size: 20 }
            })
            .then(res=>{
                this.imgsArr = res.data.results.map(item => {
                    return {
                        src: item.images[0].includes('http')?item.images[0]:`http://132.232.83.181${item.images[0]}`,
                        content: item.detail,
                        avatar: item.avatar ? (item.avatar.includes('http')?item.avatar:`http://132.232.83.181${item.avatar}`) : require('@/assets/avatar_default.png'),
                        count: item.like_count,
                        user: item.user_name
                    }
                })

                setTimeout(()=>{
                    this.$refs.waterfall.waterfallOver()
                },10)

            })
        }
    }
}
</script>
<style lang="less">
    .m-tab-wrapper {
        display: none;
    }
    .app-button-wrapper {
        display: none;
        height: 60px;
        position: fixed;
        bottom: 0;
        left: 0;
        width: 100%;
        background:rgba(255,255,255,1);
        a {
            display: block;
            margin: 5px auto 0;
            width: 128px;
            line-height: 48px;
            text-align: center;
            background:linear-gradient(90deg,rgba(254,98,157,1) 0%,rgba(252,51,100,1) 100%);
            box-shadow:0px 2px 6px 0px rgba(252,72,126,0.49);
            border-radius: 25px;
            color: #fff;
        }
    }
    .case-tab-wrapper {
        width: 1045px;
        margin: 0 auto 25px;
        display: flex;
        justify-content: space-around;
        border-bottom: 1px solid #EBEBEB;
        line-height: 50px;
        a {
            color: #000;
        }
    }
    .more {
        display: block;    
        width:343px;
        line-height:51px;
        background:linear-gradient(90deg,rgba(254,98,157,1) 0%,rgba(252,51,100,1) 100%);
        box-shadow:0px 4px 12px 0px rgba(252,72,126,0.49);
        border-radius:26px;
        margin: 40px auto;
        text-align: center;
        color: #fff;
        &:hover {
            color: #fff;
        }
    }
    .case-list-item {
        padding: 20px 12px;
        font-size: 13px;
        color: #1A1A1A;
    }
    .case-list-bottom {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-top: 20px;
        .case-list-front-wrapper {
            display: flex;
            align-items: center;
            img {
                width: 25px;
                height: 25px;
                border-radius: 50%;
                object-fit: cover;
                vertical-align: middle;
                margin-right: 8px;
                border: 1px solid #eee;
                flex-shrink: 0;
            }
            span {
                display: block;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
                font-size: 12px;
                color: #666666;
                flex-grow: 1;
            }
        }
        
        i {
            margin-left: 6px;
        }
    }
    @media (max-width: 710px) {
        .case-wrapper {
            height: calc(~"100vh - 115px");
        }
        .case-tab-wrapper, .more {
            display: none;
        }
        .m-tab-wrapper, .app-button-wrapper {
            display: block;
        }
        .vue-waterfall-easy-container .vue-waterfall-easy-scroll{
            // margin-bottom: 90px;
            padding-bottom: 90px;
        }
    }
    .van-tabs__content {
        display: none;
    }
    .case-dialog-wrapper {
        position: relative;
        text-align: center;
        .case-dialog-top {
            width: 105px;
            height: 105px;
            background: #fff;
            border-radius: 50%;
            position: absolute;
            left: 50%;
            transform: translate(-50%, -50%);
            padding: 23px;
            img {
                width: 100%;
            }
        }
        > img {
            width: 143px;
            margin-top: 40px;
            margin-bottom: 10px;
            z-index: 100;
            position: relative;
        }
    }
    .tabActive {
        border-bottom: 1px solid #000;
    }
    .van-tabs__line {
        background-color: #000;
        width: 36px;
    }
    .vue-waterfall-easy {
        .over {
            top: 0 !important;
        }
    }
</style>
